export const systemLanguages = ['he', 'ar']; // ['he', 'ar', 'en'];
export const services = {
  nairobiApi: 'nairobiapi',
};
